import { InvalidScriptContainerTypeError } from './errors';
export var ScriptContainerType;
(function (ScriptContainerType) {
    ScriptContainerType[ScriptContainerType["Transaction"] = 0] = "Transaction";
    ScriptContainerType[ScriptContainerType["Block"] = 1] = "Block";
    ScriptContainerType[ScriptContainerType["Consensus"] = 2] = "Consensus";
})(ScriptContainerType || (ScriptContainerType = {}));
const isScriptContainerType = (value) => ScriptContainerType[value] !== undefined;
export const assertScriptContainerType = (value) => {
    if (isScriptContainerType(value)) {
        return value;
    }
    throw new InvalidScriptContainerTypeError(value);
};

//# sourceMappingURL=ScriptContainer.js.map
